const firebaseDomain = process.env.NODE_ENV === 'development' ?
  `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJ_ID}/us-central1/api` :
  `https://${process.env.REACT_APP_WEB_HOST_URI}/api`

// `teacherResources` is a standalone function rather than a route on `api`,
// so it has its own base. `api` is pinned to nodejs18 and can no longer be
// deployed, which is why every backend addition since 2025 ships this way.
//
// The default goes through the Hosting rewrite, which keeps the request
// same-origin. REACT_APP_TEACHER_RESOURCES_URI overrides it with an absolute
// URL — needed on an environment where the rewrite is not deployed yet, since
// a Hosting rewrite only ships with a full frontend deploy of that site. The
// function sets `cors({origin: true})`, so the cross-origin form works too.
//
// Dev is exactly that environment: `/teacher-resources/**` is declared in
// botsim's firebase.json but has never been deployed to the dev site, so the
// path resolves to the CodeSpace SPA and every call comes back as HTML rather
// than JSON. The staging branch of pre-pipeline.js therefore sets the override
// to the function's own URL. Production leaves it unset and uses the rewrite,
// which ships with the production frontend deploy.
const teacherResourcesDomain =
  process.env.REACT_APP_TEACHER_RESOURCES_URI ||
  (process.env.NODE_ENV === 'development' ?
    `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJ_ID}/us-central1/teacherResources` :
    `https://${process.env.REACT_APP_WEB_HOST_URI}/teacher-resources`)

export { firebaseDomain, teacherResourcesDomain }
